var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sample-wrapper"},[_c('mt-button',{attrs:{"type":"primary"},on:{"click":_vm.InvokeApi}},[_vm._v("调用接口")]),_c('mt-button',{attrs:{"type":"primary"},on:{"click":_vm.generateUUID}},[_vm._v("生成UUID")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }